import React from "react";
import PropTypes from "prop-types";
import { Jumbotron, Button } from "react-bootstrap";

// No match route component
const NoMatch = ({ location }) => (
  <Jumbotron>
    <h1>Error 404</h1>
    <p>
      No route found matching: <code>{location.pathname}</code>
    </p>
    <p>
      <Button bsStyle="primary" href="/runsheets">
        Go to Runsheets
      </Button>
    </p>
  </Jumbotron>
);
NoMatch.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired
};

export default NoMatch;



// WEBPACK FOOTER //
// ./src/components/NoMatch.js